export const ALERT_TYPE_ERROR = "error";
export const ALERT_TYPE_INFO = "info";
export const ALERT_TYPE_SUCCESS = "success";
